import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Ticker } from "@/components/sections/Ticker";
import { Company } from "@/components/sections/Company";
import { FocusAreas } from "@/components/sections/FocusAreas";
import { ScienceTech } from "@/components/sections/ScienceTech";
import { Pipeline } from "@/components/sections/Pipeline";
import { Platforms } from "@/components/sections/Platforms";
import { EverySecond } from "@/components/sections/EverySecond";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";

const Landing = () => (
  <main className="bg-[#0A0A0C] text-white antialiased" data-testid="landing-root">
    <Navbar />
    <Hero />
    <Ticker />
    <Company />
    <FocusAreas />
    <ScienceTech />
    <Pipeline />
    <Platforms />
    <EverySecond />
    <Contact />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(18,18,20,0.85)",
            color: "#F8F9FA",
            border: "1px solid rgba(230,0,0,0.35)",
            backdropFilter: "blur(20px)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
